var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNycTechWeekSquiggleGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 1132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_359_5557)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_359_5557",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 1132
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1132,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_359_5557)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M-21.8699 812.005C181.55 756.736 210.352 744.968 636.115 662.395C747.67 640.76 721.313 415.554 1140.09 486.704C1538.62 554.413 1295.56 333.472 1140.03 225.749C995.172 125.414 1492.45 3.85088 1677.2 54.7046",
    stroke: "url(#paint0_linear_359_5557)",
    strokeWidth: 5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_359_5557",
    x1: 390.31,
    y1: 330.064,
    x2: 1383.65,
    y2: 368.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390231,
    stopColor: "#0E97EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819851,
    stopColor: "#23C7CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_359_5557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1132,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNycTechWeekSquiggleGraphic);
export default __webpack_public_path__ + "static/media/nyc-tech-week-squiggle-graphic.5134a1db87d2a3a403ea24a65f101a87.svg";
export { ForwardRef as ReactComponent };